'use client'

import EventService from '@/service/event.service'
import { routes } from '@/utils/routes'
import SearchIcon from '@mui/icons-material/Search'
import { Autocomplete, InputAdornment, TextField } from '@mui/material'
import { EventObjectTypeResponse } from '@repo/shared/types/event.types'
import dayjs from 'dayjs'
import huLocale from 'dayjs/locale/hu'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

dayjs.locale(huLocale)

export const EventSearch = () => {
  const [inputValue, setInputValue] = useState('')
  const [events, setEvents] = useState<ReturnType<typeof rowMapper>[]>([])
  const router = useRouter()

  const handleInputChange = (
    event: React.SyntheticEvent<Element, Event>,
    newInputValue: string,
  ) => {
    setInputValue(newInputValue)
    searchEvents(newInputValue)
  }

  const rowMapper = (event: EventObjectTypeResponse) => {
    const title = `${dayjs(event.startDate).format('HH:mm')} - ${dayjs(event.endDate).format(
      'HH:mm',
    )} ${event.title}`
    return {
      id: event.id,
      title,
      date: event.startDate,
      group: dayjs(event.startDate).format('YYYY. MMMM DD, dddd'),
    }
  }

  const searchEvents = (searchValue: string) => {
    EventService.searchEvents(searchValue)
      .then((response) => {
        setEvents(
          response.data
            .filter((event) => event.status && event.status === 'ACTIVE')
            .map((item) => {
              return rowMapper(item)
            })
            .sort(
              (a: { date: string }, b: { date: string }) =>
                new Date(a.date).getTime() - new Date(b.date).getTime(),
            ),
        )
      })
      .catch((error) => console.error('ERROR: ' + error))
  }

  return (
    <Autocomplete
      id="combo-box-demo"
      freeSolo
      inputValue={inputValue}
      onInputChange={handleInputChange}
      options={events}
      groupBy={(option: any) => option.group}
      getOptionLabel={(option: any) => option.title}
      style={{
        minWidth: 260,
        height: 40,
        borderRadius: 16,
      }}
      componentsProps={{
        paper: {
          sx: {
            margin: 0,
            marginTop: 1,
          },
        },
      }}
      onChange={(e, value) => {
        if (value && typeof value === 'object' && 'id' in value && value.id) {
          router.push(routes.publicEventDetails(value.id))
        }
      }}
      sx={{
        borderColor: 'transparent',

        '& .MuiOutlinedInput-root': {
          padding: '0px 8px',
          height: '40px',
          backgroundColor: '#F5F7FF',

          '& .MuiAutocomplete-input': {
            padding: '8px 0px',
          },
        },
      }}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            placeholder="Keresés..."
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              onKeyDown: (e) => {
                if (e.key === 'Enter') {
                  e.stopPropagation()
                }
              },
            }}
            variant="outlined"
          />
        )
      }}
    />
  )
}
